export default "__VITE_ASSET__f023d275__"